import $ from "jquery";
import _ from "underscore";
import IScroll from "IScroll";
import {isIE8, isMSIE} from "../atBrowserUtils";

const ScrollUtils = {};

ScrollUtils.POSITIONS = {
    TOP: 'top',
    CENTER: 'center',
    BOTTOM: 'bottom',
    LEFT: 'left',
    RIGHT: 'right'
};

/**
 * Add horizontal scroll to element - wrapper
 * if browser is ie8 then set custom scroll with mouse wheel event
 * @param jqEl - element wrapper (has has scrollable first child)
 * @param options like isFaded - if need to hide scroll when it not used
 */
ScrollUtils.addHorizontalScroll = function(jqEl, options)
{
    var scroll = null;
    if (isIE8())
    {
        jqEl.css("overflow-x", "scroll"); // set correct overflow-x property
        var scrollDelta = 30;
        jqEl.on(ScrollUtils.getWheelEventName(), function(e)
        {
            var delta = e.originalEvent.deltaY || e.originalEvent.detail || (-1 * e.originalEvent.wheelDelta);

            if (jqEl.outerWidth() != jqEl[0].scrollWidth)
            {
                var currentScrLeft = jqEl.scrollLeft();
                if (delta > 0)
                {
                    jqEl.scrollLeft(currentScrLeft + scrollDelta);
                }
                else
                {
                    jqEl.scrollLeft(currentScrLeft - scrollDelta);
                }
                e.preventDefault();
            }
        });
    }
    else
    {
        jqEl.css("overflow-x", "hide"); // set correct overflow-x property
        scroll = ScrollUtils.getCustomScroll(jqEl, false, options);
    }
    return scroll;
};

/**
 * Add vertical scroll to element - wrapper
 * if browser is ie8 then used std scroll
 * @param jqEl - element wrapper (has has scrollable first child)
 * @param options like isFaded - if need to hide scroll when it not used
 */
ScrollUtils.addVerticalScroll = function(jqEl, options)
{
    var scroll = null;
    if (isIE8())
    {
        jqEl.css("overflow-y", "scroll"); // set correct overflow-x property
    }
    else
    {
        jqEl.css("overflow-y", "hidden"); // set correct overflow-x property
        scroll = ScrollUtils.getCustomScroll(jqEl, true, options);
    }
    return scroll;
};

ScrollUtils.getCustomScroll = function(jqEl, isVertical, options)
{
    options = _.isUndefined(options) ? {isFaded: false, mouseWheel: true, appendTo: null} : options;
    var isFaded = _.isUndefined(options.isFaded) ? false : options.isFaded;
    var mouseWheel = _.isUndefined(options.mouseWheel) ? true : options.mouseWheel;

    var customScroll = new IScroll(jqEl[0], {
        scrollX: !isVertical,
        scrollY: isVertical,
        mouseWheel: mouseWheel,
        bounce: false, // no need (animation)
        interactiveScrollbars: true, // allow user actions
        fadeScrollbars: isFaded, //at first time always hide scrollbars
        scrollbars: 'custom', // custom styles for scroller @see customscroll.less
        disableMouse: true, //disable drag by mouse event
        disablePointer: true, //disable drag by pointer event
        disableTouch: true, //disable drag by touch event
        probeType: options.probeType
    });

    if (options.appendTo)
    {
        var scrollClass = isVertical ? ".iScrollVerticalScrollbar" : ".iScrollHorizontalScrollbar";
        var scroll = jqEl.find(scrollClass);
        options.appendTo.append(scroll);
    }

    // function checks if there is overflow content for current custom scroll
    var isScrollNeeded = function()
    {
        return isVertical ? customScroll.hasVerticalScroll : customScroll.hasHorizontalScroll;
    };

    var indicator = customScroll.indicators[0];
    // hide scroll placeholder if there is no scrollable content
    customScroll.on("refresh", function()
    {
        indicator.wrapperStyle[IScroll.utils.style.transitionDuration] = 0 + 'ms';
        indicator.wrapperStyle.visibility = isScrollNeeded() ? 'visible' : 'hidden';
    });
    if (isFaded)
    {
        jqEl.hover(
                function()
                {
                    if(isScrollNeeded()){
                        indicator.fade(1);
                    }
                },
                function()
                {
                    if(isScrollNeeded()){
                        indicator.fade();
                    }
                }
        );
    }

   setTimeout(
            function()
            {
                customScroll.refresh();
            },
            0.1
    );
    customScroll.refresh();

    return customScroll;
};

ScrollUtils.refreshCustomScroll = function(customScroll)
{
    if (customScroll)
    {
        customScroll.refresh();
    }
};

/**
 * Scroll element vertical to visible are (if there is no custom scroll - scroll by jquery)
 * @param customScroll object of custom scroll for perform scrolling
 * @param element element for scrolling
 * @param position top/bot/center in visible area
 * @param onlyIfElIsNotVisible scroll only of element is not fully visible
 * @param time for scrolling (duration of animation)
 */
ScrollUtils.scrollIntoViewVertical = function(customScroll, element, position = ScrollUtils.POSITIONS.TOP, onlyIfElIsNotVisible, time) {
    let pos
    let offset = 0
    if (_.isString(position)) {
        pos = position
    } else {
        pos = position.pos || ScrollUtils.POSITIONS.TOP
        offset = position.offset || 0
    }
    time = time || 0;
    if (customScroll) {
        if (!onlyIfElIsNotVisible || !ScrollUtils.isElementIsFullyVisibleVertical(customScroll, element)) {
            let offsetY = -offset
            if (pos === ScrollUtils.POSITIONS.CENTER) {
                offsetY -= -Math.round(IScroll.utils.getRect(element).height / 2 - IScroll.utils.getRect(customScroll.wrapper).height / 2)
            }
            if (pos === ScrollUtils.POSITIONS.BOTTOM) {
                offsetY -= customScroll.wrapperHeight - element.offsetHeight;
            }
            customScroll.scrollToElement(element, time, null, offsetY)
        }
    }
    else {
        $(element).scrollintoview({duration: time});
    }
};

ScrollUtils.scrollToTop = function(customScroll, $containerEl, time = 0) {
    if (customScroll) {
        customScroll.scrollTo(0, 0, time);
    } else {
        $containerEl.scrollTop(0);
    }
};

ScrollUtils.scrollToBottom = (customScroll) => {
    if (customScroll) {
        customScroll.scrollTo(0, customScroll.maxScrollY);
    }
};

ScrollUtils.performIfScrollToBottom = (customScroll, verticalGap, callback) => {
    if (!customScroll || customScroll.y - customScroll.maxScrollY < verticalGap) {
        callback()
    }
}

ScrollUtils.performIfScrollToTop = (customScroll, verticalGap, callback) => {
    if (!customScroll || Math.abs(customScroll.y) <= verticalGap) {
        callback()
    }
}

ScrollUtils.isElementIsFullyVisibleVertical = function(customScroll, element)
{
    if (customScroll)
    {
        var elTopOffsetPos = element.offsetTop;
        var elBottomOffsetPos = element.offsetTop + element.offsetHeight;

        var isTopOfElementIsVisible = elTopOffsetPos >= Math.abs(customScroll.y);
        var isBottomOfElementIsVisible = elBottomOffsetPos <= (Math.abs(customScroll.y) + customScroll.wrapperHeight);
        return isTopOfElementIsVisible && isBottomOfElementIsVisible;
    }
    return false;
};

/**
 * Scroll element horizontal to visible area(if custom is not exists - scroll by jquery )
 * @param customScroll object of custom scroll
 * @param element element for scrolling
 * @param position left/right/center on visible area
 * @param time for scrolling (duration of animation)
 */
ScrollUtils.scrollIntoViewHorizontal = function(customScroll, element, position, time)
{
    var pos = position || ScrollUtils.POSITIONS.RIGHT;
    time = time || 0;
    if (customScroll)
    {
        var offsetX = null;
        if (pos == ScrollUtils.POSITIONS.CENTER)
        {
            offsetX = true;
        }
        if (pos == ScrollUtils.POSITIONS.LEFT)
        {
            offsetX = -(customScroll.wrapperWidth - element.offsetWidth);
        }
        customScroll.scrollToElement(element, time, offsetX);
    }
    else
    {
        $(element).scrollintoview({duration: time});
    }
};

ScrollUtils.getWheelEventName = function()
{
    var wheelEventName = "";
    if ('onwheel' in document)
    {
        // IE9+, FF17+, Ch31+
        wheelEventName = "wheel";
    }
    else if ('onmousewheel' in document)
    {
        // old event
        wheelEventName = "mousewheel";
    }
    else
    {
        // Firefox < 17
        wheelEventName = "MozMousePixelScroll";
    }
    return wheelEventName;
};

/**
 * Returns custom listener for mouse wheel event
 * When mouse wheel event fires over element and element has scroll and scroll bar reaches top or bot position
 * by default parent element start scrolling
 * Default behavior not convenient for popups and selectors with scroll
 * This listener eliminate default behavior
 * Listener need to apply to element that has scroll or for element - parent of element(s) with scroll
 * Uses delegated event
 * For use into another handlers need to bind context of outer handler with context of this function
 */
ScrollUtils.getWheelEventListenerForPreventScrollParents = function()
{
    return function(e)
    {
        var target = e.target;

        // this - context of element that has this listener 
        // delegate event from target to scrollable element if exist
        while( target && target != this.parentNode) {

            var scrlEl = $(target);

            // if inner height not eq scroll height - maybe  element has a scroll
            if(scrlEl.innerHeight() != scrlEl[0].scrollHeight) {

                // but heights may not equals is overflow is "hidden" or "visible"
                var overflowStyle = scrlEl.css("overflow-y");
                var isOverflowHidden = overflowStyle ==  "hidden";
                var isOverflowVisible = overflowStyle == "" || overflowStyle == "visible";

                // check overflow styles
                if(!isOverflowHidden && !isOverflowVisible) {
                    // calculate scroll delta(for ie it has inverted value)
                    var delta = e.originalEvent.deltaY || e.originalEvent.detail || (-1 * e.originalEvent.wheelDelta);
                    // for ie
                    if(isMSIE()) {
                        // prevent scroll window if delta is big (ie has acceleration)
                        if(scrlEl.scrollTop() + delta <= 0 ){
                            scrlEl.scrollTop(0);
                            e.preventDefault();
                            return;
                        }
                        var scrollMaxBottomPosition = scrlEl[0].scrollHeight - scrlEl.outerHeight(true);
                        if(scrlEl.scrollTop() + delta > scrollMaxBottomPosition){
                            scrlEl.scrollTop(scrollMaxBottomPosition);
                            e.preventDefault();
                            return;
                        }
                    }
                    // if scroll on top - prevent scroll to top
                    if (delta < 0 && scrlEl.scrollTop() == 0) {
                        e.preventDefault();
                        return;
                    }
                    // if scroll on bot - prevent scroll to bot
                    if (delta > 0 &&
                        (scrlEl[0].scrollHeight - scrlEl.outerHeight(true) - scrlEl.scrollTop()) <= 1)
                    {
                        e.preventDefault();
                        return;
                    }

                    return;
                }
            }
            target = target.parentNode;
        }
    };
};

export default ScrollUtils;


// WEBPACK FOOTER //
// ./web/js/util/ScrollUtils.js